export default __webpack_public_path__ + "static/media/VI_Old_Black.57d60649.png";